import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal as BsModal } from 'react-bootstrap';
import { CgClose } from 'react-icons/cg';
export const Header = ({ title, onClose }) => {
    if (!title)
        return null;
    return (_jsxs(BsModal.Header, Object.assign({ className: 'd-flex align-items-centers' }, { children: [_jsx(BsModal.Title, { children: title }), _jsx(CgClose, { className: 'btn-icon', size: 24, onClick: onClose })] })));
};
